export default __webpack_public_path__ + "static/best-countries-for-shopaholics-hero-image-a95a4d6a70312dcd1794df1011def9a8.jpg";